"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _UIAbstractNumberInput = _interopRequireDefault(require("./abstract/UIAbstractNumberInput"));

var _UITextInput = _interopRequireDefault(require("./UITextInput"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

function UINumberInput(_ref) {
  var className = _ref.className,
      type = _ref.type,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "type"]);

  if (type !== _UITextInput.default.defaultProps.type) {
    _devLogger.default.warn({
      message: 'UINumberInput: The `type` prop is a no-op (#4178)',
      key: 'UINumberInput: type'
    });
  }

  return _react.default.createElement(_UIAbstractNumberInput.default, props, function (numberProps) {
    return _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, numberProps, {
      className: (0, _classnames.default)('uiNumberInput', className),
      type: "text"
    }));
  });
}

UINumberInput.propTypes = (0, _extends2.default)({}, (0, _omit.default)(_UITextInput.default.propTypes, ['type']), (0, _omit.default)(_UIAbstractNumberInput.default.propTypes, ['children']));
UINumberInput.defaultProps = (0, _extends2.default)({}, _UITextInput.default.defaultProps, _UIAbstractNumberInput.default.defaultProps);
UINumberInput.displayName = 'UINumberInput';

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UINumberInput));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/input/UINumberInput.js
// module id = 317
// module chunks = 5 6